import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import { createLocationModel } from "../../../services/order";
import Markers from "../../../services/markers";
import { getDefaultRegion, getRegionById } from '../../../services/restaurant';
import { DELIVERY_ZONE_TYPE } from "../../../utils/enums";

import PortalServiceMap from "../PortalMap";

class MapRegionControl extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      markers: [],
      center: null,
      region: null,
      circle: null
    };
  }

  componentDidMount() {    
    this.updateRegionData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props;
    if (value !== prevProps.value) {
      this.updateRegionData();     
    }
  }

  updateRegionData = () => {
    const { item, value, column, restaurant } = this.props;
    const defaultPolygonLocations = getDefaultRegion((item.businessMenu || {}).location)
    if(!item || !column)
      return;
    const data = {
      markers: column.isHideDepots 
        ? (item.marker ? [Markers.instance.createDefaultMarker(item.marker, column.typeMarker)] : [])
        : Markers.instance.getRestaurantMarkers(restaurant),
      center: (item.marker || {}).location
    };

    switch (item.type) {
      case DELIVERY_ZONE_TYPE.reference:
        data.region = getRegionById(value);
        break;
      case DELIVERY_ZONE_TYPE.circle:
        data.circle = value;
        break; 
      case DELIVERY_ZONE_TYPE.polygon:    
      default:
        data.region = { id: item.id, locations: value ? value : defaultPolygonLocations };
        break;
    } 

    this.setState(data); 
  }

  handleOnMapClick = clickLocation => {
    const { column } = this.props;
    if(column.isReadonly){
      return;
    }

    const location = createLocationModel(clickLocation.lat, clickLocation.lng);
    this.setState({ center: location });
  };

  handleOnRegionChange = data => {
    const { circle } = this.state;
    const { onPropChange, column } = this.props;

    if(column.isReadonly){
      return;
    }
    
    if(!circle) {
      onPropChange({ region: data });
    } else {
      onPropChange({ circle: data });
    }
  }

  render() {
    const { markers, center, region, circle } = this.state;
    const { t, column } = this.props;

    return (
      <div className={classNames("mapRegionControl")}>
        <PortalServiceMap
          markers={markers}
          center={center}
          region={region}
          circle={circle}
          boundsByRegion={column.boundsByRegion}
          boundsByCircle={column.boundsByCircle}
          isHidePolygon={column.isHidePolygon}
          isReadonly={column.isReadonly}
          handleOnMapClick={this.handleOnMapClick}
          onRegionChange={this.handleOnRegionChange}
        />
        {region && (
          <div className={classNames("labelInfo")}>
            {t("mapEditor.REMOVE_POINT_LABEL")}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  restaurant: state.restaurant.data
});

export default connect(mapStateToProps)(withTranslation()(MapRegionControl));
